
import React from 'react';
import Layout from '@/components/layout/Layout';
import PromotionHero from '@/components/promotion/PromotionHero';
import HotDeals from '@/components/promotion/HotDeals';
import SeasonalCoupons from '@/components/promotion/SeasonalCoupons';
import SpecialPromotions from '@/components/promotion/SpecialPromotions';

const Promotion: React.FC = () => {
  return (
    <Layout>
      <div className="pt-24 pb-12">
        <PromotionHero />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
          <HotDeals />
          <SeasonalCoupons />
          <SpecialPromotions />
        </div>
      </div>
    </Layout>
  );
};

export default Promotion;
